import { StyleSheet } from 'react-native';

import { AppColors } from '../services/styles';

const RichTextDisplay = (props) => {
  const content = { __html: props.html || '' };
  const propsStyle = props.style || {};

  return (
    <div
      style={StyleSheet.flatten([styles.rtdDiv, propsStyle])}
      className="RichText"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: we need this!
      dangerouslySetInnerHTML={content}
    />
  );
};

const styles = StyleSheet.create({
  rtdDiv: {
    color: AppColors.darkText
  }
});

export { RichTextDisplay };
